// extracted by mini-css-extract-plugin
export var container = "Joulukalenteri-module--container---cYzZ";
export var effect = "Joulukalenteri-module--effect--ih7Ou";